import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/services/apiService';
import { firstValueFrom } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

interface DropdownItem {
  key: string;
  value: string;
}

interface ExamItem {
  nationalId: string;
  appplicantName: string;
  applicationNumber: string;
  carbonId: string;
  committeeType: number;
  examinationDate: string;
  examinationTime: string;
  phoneNumber1: string;        // ✅ added
  phoneNumber2?: string | null; // ✅ optional
}

@Component({
  selector: 'app-exam-dates',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule
  ],
  templateUrl: './exam-dates.component.html',
  styleUrl: './exam-dates.component.css'
})
export class ExamDatesComponent implements OnInit {

  dropdownList: DropdownItem[] = [];
  selectedCommittee = '';
  selectedDate = '';
  selectedTime: string | null = null;

  exams: ExamItem[] = [];

  loading = false;
  submitted = false;

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.getDropdownData();
  }

  onTimeChange(value: string | null) {
    this.selectedTime = value || null;
  }

  async getDropdownData() {
    this.loading = true;
    try {
      const req = this.apiService.getGetter('HCDLookup/GetTypeOfDisabilites');
      const res: any = await firstValueFrom(req);
      this.dropdownList = res.list || [];
    } catch (error) {
      console.error('Error in getDropdownData:', error);
    } finally {
      this.loading = false;
    }
  }

  formatDate(date: string): string {
    if (!date) return '';
    return `${date} 00:00:00.0000000`;
  }

  async search() {
    this.submitted = true;

    if (!this.selectedCommittee || !this.selectedDate) return;

    this.loading = true;

    try {
      const formattedDate = this.formatDate(this.selectedDate);

      let query = `IdentificationCardApplication/GetExaminationDates?committeeType=${encodeURIComponent(this.selectedCommittee)}&examinationDate=${formattedDate}`;

      // ✅ only send time if user selected it
      if (this.selectedTime) {
        query += `&examinationTime=${encodeURIComponent(this.selectedTime)}`;
      }

      const req = this.apiService.getGetter(query);
      const res: any = await firstValueFrom(req);

      // ✅ normalize phone2 (important for UI)
      this.exams = (res || []).map((item: any) => ({
        ...item,
        phoneNumber2: item.phoneNumber2?.trim() || null
      }));

    } catch (error) {
      console.error('Search error:', error);
    } finally {
      this.loading = false;
    }
  }
// if i want to format time from 24h to 12h with am/pm in future just add this to html :{{ formatTime(exam.examinationTime) }}
formatTime(time: string): string {
  if (!time) return '-';

  const [hourStr, minute] = time.split(':');
  let hour = +hourStr;

  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour = hour % 12;
  hour = hour ? hour : 12;

  return `${hour}:${minute} ${ampm}`;
}

}



